import { CUSTOMER_KEYS } from '@/queries/customer/customer.keys';
import { BASE_QUERY_KEYS } from '@/queries/consts';

export const QUOTES_KEYS = {
  main: 'quotes',
};

export const quotesQueryKeys = {
  getQuote: (...args: unknown[]) => [QUOTES_KEYS.main, BASE_QUERY_KEYS.item, ...args] as const,
  getCustomerQuote: (...args: unknown[]) =>
    [QUOTES_KEYS.main, BASE_QUERY_KEYS.item, CUSTOMER_KEYS.main, ...args] as const,
};
